import { render } from "./StaticPages.vue?vue&type=template&id=0a1a6cf8"
import script from "./StaticPages.vue?vue&type=script&lang=js"
export * from "./StaticPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__